// apps/website/src/components/SmartlookTracker.tsx

import { useEffect } from 'react';

// Best Practice: Use environment variables for sensitive keys.
// Create a .env file in your `apps/website` root if you don't have one.
// Add this line to it: VITE_SMARTLOOK_PROJECT_KEY="YOUR_PROJECT_KEY_HERE"
const SMARTLOOK_PROJECT_KEY = import.meta.env.VITE_SMARTLOOK_PROJECT_KEY;

/**
 * A side-effect component that initializes the Smartlook session recorder.
 * It runs once when the application mounts and does not render any UI.
 */
export const SmartlookTracker = () => {
  useEffect(() => {
    // Only run this logic in the browser and if the key is provided.
    if (typeof window === 'undefined' || !SMARTLOOK_PROJECT_KEY) {
      if (!SMARTLOOK_PROJECT_KEY) {
        console.warn('Smartlook tracking is disabled: VITE_SMARTLOOK_PROJECT_KEY is not set.');
      }
      return;
    }

    // Standard Smartlook initialization script.
    // This will only run once on initial app load.
    if (!(window as any).smartlook) {
      (window as any).smartlook = function() {
        (window as any).smartlook.api.push(arguments);
      };
      (window as any).smartlook.api = [];

      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.src = 'https://web-sdk.smartlook.com/recorder.js';
      head.appendChild(script);

      (window as any).smartlook('init', SMARTLOOK_PROJECT_KEY, { region: 'eu' });
      console.log('Smartlook Tracker Initialized.');
    }
  }, []); // Empty dependency array ensures this runs only once.

  // This component renders nothing.
  return null;
};